module.exports = __webpack_public_path__ + "img/Vector 2.6dc32d18.svg";